import { localStorageInstance } from '@gem/modules/storage';

const KEY_NAME = 'secret-chats-onboarding';

export const set = (value: boolean): void => {
  return localStorageInstance.setItem(KEY_NAME, JSON.stringify(value));
};

export const get = (): boolean => {
  const data = localStorageInstance.getItem(KEY_NAME);

  return data === 'true';
};

export const remove = (): void => {
  return localStorageInstance.removeItem(KEY_NAME);
};
